/* eslint-disable react/sort-comp */
import React from 'react';
import $ from 'jquery';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import ComparisonProviderFormComponent from './ComparisonProviderFormComponent';
import ComparisonMortgageFormComponent from './ComparisonMortgageFormComponent';
import ComparisonLoanpartsFormComponent from './ComparisonLoanpartsFormComponent';
import PrimaryButton from '../../shared_components/buttons/PrimaryButtonComponent';

@observer
class ComparisonFormComponent extends React.Component {
  defaultText = 'Maak aub een keuze';

  constructor(props) {
    super(props);
    this.setProvidersSelectText = this.setProvidersSelectText.bind(this);
    this.setSelectInputText = this.setSelectInputText.bind(this);
    this.selectProvidersSelectText = this.selectProvidersSelectText.bind(this);
    this.selectLabelsSelectText = this.selectLabelsSelectText.bind(this);
    this.compareProviders = this.compareProviders.bind(this);
    this.setProvider = this.setProvider.bind(this);
    this.setLabel = this.setLabel.bind(this);
  }

  componentDidMount() {
    const { firstLabelName, secondLabelName } = this.props.ComparisonFormData;

    this.setSelectInputText(firstLabelName, this.defaultText);
    this.setSelectInputText(secondLabelName, this.defaultText);
  }

  compareProviders() {
    this.props.ComparisonFormData.compareProviders().then((res) => {
      if (res) {
        const $comparisonInterestGraph = $('.comparison-container__interest-comparison-graph');
        if ($comparisonInterestGraph.length > 0) {
          $('html, body').animate({ scrollTop: $comparisonInterestGraph.offset().top }, 600);
        }
      }
    });
  }

  setProvider(value, providerName) {
    const {
      setProvider,
    } = this.props.ComparisonFormData;
    setProvider(value, providerName);
  }

  setLabel(value, labelName) {
    this.props.ComparisonFormData.setLabel(value, labelName);
    this.props.ComparisonFormData.resetLoanpartsPostData();
    this.setSelectInputText('frt', this.defaultText);
    this.props.ComparisonFormData.getFixedRateTerms();
  }

  selectProvidersSelectText(providers, providerId, providerName) {
    const selectedProvider = providers.find(provider => provider.id === providerId);
    if (selectedProvider) {
      this.setProvidersSelectText(providerName, selectedProvider.name);
    }
  }

  selectLabelsSelectText(labels, labelId, labelName) {
    const selectedLabel = labels.find(label => label.id === labelId);
    if (selectedLabel) {
      this.setSelectInputText(labelName, selectedLabel.labelName);
    }
  }

  setProvidersSelectText(providerName, selectedProvider) {
    $(`select[name=${providerName}]`)
      .siblings('.text')
      .text(selectedProvider);
  }

  setSelectInputText(labelName, selectedLabel) {
    $(`select[name=${labelName}]`)
      .siblings('.text')
      .text(selectedLabel);
  }

  render() {
    const {
      firstProviderId,
      firstLabelId,
      secondProviderId,
      secondLabelId,
      loanparts,
      firstFilteredLabels,
      secondFilteredLabels,
      firstLabelName,
      secondLabelName,
      firstProviderName,
      secondProviderName,
    } = this.props.ComparisonFormData;

    const { allProviders, allLabels } = this.props.ProviderLabelData;
    const showCalculationButton = true;

    this.selectProvidersSelectText(allProviders, firstProviderId, firstProviderName);
    this.selectProvidersSelectText(allProviders, secondProviderId, secondProviderName);
    this.selectLabelsSelectText(allLabels, firstLabelId, firstLabelName);
    this.selectLabelsSelectText(allLabels, secondLabelId, secondLabelName);

    return (
      <div>
        <div className="row columns comparison-provider-form">
          <ComparisonProviderFormComponent
            setProvider={this.setProvider}
            setLabel={this.setLabel}
            classNames="medium-42 columns bottomPadding"
            providerId={firstProviderId}
            labelId={firstLabelId}
            providers={allProviders}
            labels={firstFilteredLabels}
            labelName={firstLabelName}
            providerName={firstProviderName}
          />
          <ComparisonProviderFormComponent
            setProvider={this.setProvider}
            setLabel={this.setLabel}
            classNames="medium-42 columns verticalDivider bottomPadding"
            providerId={secondProviderId}
            labelId={secondLabelId}
            providers={allProviders}
            labels={secondFilteredLabels}
            labelName={secondLabelName}
            providerName={secondProviderName}
          />
        </div>
        <hr className={'linearGradient'} />
        <div className="medium-74 medium-offset-5">

          <ComparisonMortgageFormComponent />

          <ComparisonLoanpartsFormComponent
            show={loanparts.length > 0 && firstLabelId > 0 && secondLabelId > 0}
          />

          <div className="columns medium-15 float-right">
            <PrimaryButton
              onClickHandler={this.compareProviders}
              show={showCalculationButton}
              href="#"
              text="Berekenen"
            />
          </div>

        </div>
      </div>
    );
  }
}

ComparisonFormComponent.propTypes = {
  ProviderLabelData: PropTypes.shape({
    allProviders: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    allLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  ComparisonFormData: PropTypes.shape({
    loanparts: PropTypes.arrayOf(PropTypes.number),
    firstFilteredLabels: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({}),
    ]),
    secondFilteredLabels: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({}),
    ]),
    setLabel: PropTypes.func,
    resetLoanpartsPostData: PropTypes.func,
    compareProviders: PropTypes.func,
    getFixedRateTerms: PropTypes.func,
    firstProviderId: PropTypes.number,
    firstLabelId: PropTypes.number,
    secondProviderId: PropTypes.number,
    secondLabelId: PropTypes.number,
    responseError: PropTypes.string,
    firstLabelName: PropTypes.string,
    secondLabelName: PropTypes.string,
    firstProviderName: PropTypes.string,
    secondProviderName: PropTypes.string,
    setProvider: PropTypes.func,
    resetSelectedLabelId: PropTypes.func,
  }),
};

ComparisonFormComponent.defaultProps = {
  ProviderLabelData: {
    allProviders: [],
    allLabels: [],
  },
  ComparisonFormData: {
    firstFilteredLabels: [],
    secondFilteredLabels: [],
    loanparts: [],
    setLabel: () => {},
    resetLoanpartsPostData: () => {},
    compareProviders: () => {},
    getFixedRateTerms: () => {},
    firstProviderId: 0,
    firstLabelId: 0,
    secondProviderId: 0,
    secondLabelId: 0,
    responseError: '',
    firstLabelName: '',
    secondLabelName: '',
    firstProviderName: '',
    secondProviderName: '',
    setProvider: () => {},
    resetSelectedLabelId: () => {},
  },
};

export default inject('ComparisonFormData', 'ProviderLabelData')(ComparisonFormComponent);
